<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <div class="col-12 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle d-block">Lista</span>
        <h3 class="page-title d-inline">Respostas dos usuários</h3>
      </div>
    </d-row>

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="card-small mb-4">
          <div class="card-header border-bottom d-flex">
            <div class="col-6">
              <h6 class="m-0">Avaliações enviadas</h6>
            </div>
          </div>
          <div class="card-body p-0 pb-3 text-left">
            <div class="table-overflow">
              <rating-user-table :users="answers.list" type="ticket"/>
            </div>
            <pagination :total-items="answers.total_items" :pagination.sync="pagination"></pagination>
          </div>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import Pagination from '_shared/Pagination.vue';
import RatingUserTable from '../components/RatingUserTable.vue';

export default {
  name: 'user-answer-ist',
  components: {
    Pagination,
    RatingUserTable,
  },
  data() {
    return {
      pagination: {
        id: 1,
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
      },
    };
  },
  computed: {
    answers() {
      const { answers } = this.$store.state.rating;
      if (answers && answers.list.length) {
        return answers;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
  },
  watch: {
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getAnswersList',
    ]),
    getList() {
      this.getAnswersList(this.pagination);
    },
  },
  mounted() {
    Events.$emit('sidebarVisible', false);
    Events.$on('update:pagination', pagination => {
      this.$router.push({ params: { page: pagination.page } });
      this.getList();
    });
    this.getList();
  },

};
</script>

<style lang="scss" scoped>
</style>
